import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_fr';
import Cleave from 'cleave.js';
import 'cleave.js/src/addons/phone-type-formatter.fr';
import { Alert } from '../functions';

// eslint-disable-next-line no-undef
const object = gralObject;

if ($('.gral-phone-input').length) {
    new Cleave('.gral-phone-input', {
        phone: true,
        phoneRegionCode: 'FR',
    });
}

const gralForm = $('.contact-template__form--gral');

gralForm.validate({
    onsubmit: true,
    rules: {
        'products[]': {
            required: true,
            minlength: 1,
        },
        'industry[]': {
            required: true,
            minlength: 1,
        },
        'clientele[]': {
            required: true,
            minlength: 1,
        },
    },
    messages: {
        'products[]': object.formErrorAtLeast,
        'industry[]': object.formErrorAtLeast,
        'clientele[]': object.formErrorAtLeast,
    },
    errorPlacement: function (error, element) {
        if (element.attr('data-parent-validate') === 'true') {
            error.prependTo(element.parents('.custom-checkbox-wrapper'));
        } else {
            error.insertAfter(element);
        }
    },
    submitHandler: function (form, event) {
        const $form = $(form);
        event.preventDefault();
        event.stopPropagation();

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data: $form.serialize() + '&action=gral_mdd_contact_form_ajax_handle',
            beforeSend: () => {
                $form.addClass('sending');
                Alert('warning', object.formWait, false);
            },
            success: (res) => {
                $form.removeClass('sending');

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect;
                }

                if (!res.success) {
                    Alert(res.success, res.data.message);
                }
            },
            complete: () => {
            },
        });
    },
    invalidHandler: () => {
        Alert(false, object.formError, 4000);
    },
});

const mddForm = $('.contact-template__form--mdd');

mddForm.validate({
    onsubmit: true,
    submitHandler: function (form, event) {
        const $form = $(form);
        event.preventDefault();
        event.stopPropagation();

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data: $form.serialize() + '&action=gral_mdd_contact_form',
            beforeSend: () => {
                $form.addClass('sending');
                Alert('warning', object.formWait, false);
            },
            success: (res) => {
                $form.removeClass('sending');

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect;
                }

                if (!res.success) {
                    Alert(res.success, res.data.message);
                }
            },
            complete: () => {
            },
        });
    },
    invalidHandler: () => {
        Alert(false, object.formError, 4000);
    },
});

const joinGral = $('.contact-template__form--join-gral');

joinGral.validate({
    onsubmit: true,
    submitHandler: function (form, event) {
        const $form = $(form);
        event.preventDefault();
        event.stopPropagation();

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data: $form.serialize() + '&action=gral_join_gral_contact_form',
            beforeSend: () => {
                $form.addClass('sending');
                Alert('warning', object.formWait, false);
            },
            success: (res) => {
                $form.removeClass('sending');

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect;
                }

                if (!res.success) {
                    Alert(res.success, res.data.message);
                }
            },
            complete: () => {
            },
        });
    },
    invalidHandler: () => {
        Alert(false, object.formError, 4000);
    },
});

$('.contact-template__establishment-button').on('click', (e) => {
    const $this = $(e.target);
    const parent = $this.parents('.contact-template__establishment');
    const input = parent.find('input');

    $this.toggleClass('contact-template__establishment-button--light');
    parent.toggleClass('contact-template__establishment--active');

    if (parent.hasClass('contact-template__establishment--active')) {
        input.prop('disabled', false).focus();
    } else {
        input.prop('disabled', true);
    }
});

$('.contact-template__establishment-closer').on('click', () => {
    $('.contact-template__establishment-button').click();
});
